// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"ed78dcc0","350":"008c2524","368":"e2bbff33","453":"5d79306b","483":"7c771917","697":"d54ba405"}[chunkId] + ".chunk.js";
};